<template>
  <div class="legal-page">
    <Navigation />

    <h1>{{ $t('legal.imprint.title') }}</h1>
    
    <section class="legal-section">
      <p class="legal-basis">{{ $t('legal.imprint.legalBasis') }}</p>

      <h2>{{ $t('legal.imprint.providerTitle') }}</h2>
      <p>{{ $t('legal.imprint.company') }}</p>
      <p>{{ $t('legal.imprint.representative') }}</p>
      <p>{{ $t('legal.imprint.street') }}</p>
      <p>{{ $t('legal.imprint.city') }}</p>

      <h2>{{ $t('legal.imprint.registerTitle') }}</h2>
      <p>{{ $t('legal.imprint.registerName') }}</p>
      <p>{{ $t('legal.imprint.registerNumber') }}</p>
      <p>{{ $t('legal.imprint.ein') }}</p>
      <p>
        <a :href="sunbizSearchResultUrl" target="_blank" rel="noopener noreferrer">
          {{ $t('legal.imprint.registerLink') }}
        </a>
      </p>
      
      <h2>{{ $t('legal.imprint.contactTitle') }}</h2>
      <p>{{ $t('legal.imprint.phone') }}</p>
      <p>{{ $t('legal.imprint.email') }}</p>

      <h2>{{ $t('legal.imprint.liabilityContentTitle') }}</h2>
      <p>{{ $t('legal.imprint.liabilityContentText') }}</p>

      <h2>{{ $t('legal.imprint.liabilityLinksTitle') }}</h2>
      <p>{{ $t('legal.imprint.liabilityLinksText') }}</p>

      <h2>{{ $t('legal.imprint.copyrightTitle') }}</h2>
      <p>{{ $t('legal.imprint.copyrightText') }}</p>
      
      <h2>{{ $t('legal.imprint.disputeTitle') }}</h2>
      <p>{{ $t('legal.imprint.disputeDecline') }}</p>
    </section>

    <LegalFooter />
  </div>
</template>

<script>
import Navigation from '../sections/Navigation.vue'
import LegalFooter from './LegalFooter.vue'

const SUNBIZ_SEARCH_RESULT_URL =
  'https://search.sunbiz.org/Inquiry/CorporationSearch/SearchResultDetail?inquirytype=EntityName&directionType=Initial&searchNameOrder=PERSONALCODING%20L260001224410&aggregateId=flal-l26000122441-cacb25fe-97e8-4a3b-a5bd-f70eeaa50878&searchTerm=Personal%20coding&listNameOrder=PERSONALCODING%20L260001224410'

export default {
  name: 'LegalImpressum',
  components: { Navigation, LegalFooter },
  data() {
    return {
      sunbizSearchResultUrl: SUNBIZ_SEARCH_RESULT_URL
    }
  }
}
</script>

<style scoped>
.legal-page {
  max-width: 800px;
  margin: 0 auto;
  padding: 120px 20px 0;
  color: #e2e8f0;
  min-height: 100vh;
}

h1 {
  font-size: 3rem;
  margin-bottom: 40px;
  color: #ffffff;
  text-align: center;
  font-weight: 700;
}

.legal-section {
  background: rgba(15, 16, 35, 0.85);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #e2e8f0;
  padding: 40px;
  border-radius: 15px;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.4);
  margin-bottom: 30px;
}

.legal-basis {
  font-size: 0.9rem;
  opacity: 0.8;
  margin-bottom: 24px;
}

h2 {
  color: #ffffff;
  margin: 30px 0 15px;
  font-size: 1.5rem;
  font-weight: 600;
  border-bottom: 2px solid #00ffb3;
  padding-bottom: 8px;
}

p {
  margin: 10px 0;
  line-height: 1.6;
  color: #e2e8f0;
}

a {
  color: #22d3ee;
  text-decoration: none;
}

a:hover {
  color: #667eea;
  text-decoration: underline;
}

@media (max-width: 768px) {
  .legal-page {
    padding-top: 100px;
  }

  h1 {
    font-size: 2.5rem;
  }

  .legal-section {
    padding: 30px 20px;
  }
}
</style>
